let globalProps = null;

export function setAppGlobals(app) {
  globalProps = app.config.globalProperties;
}

export function getAppGlobals() {
  if (!globalProps) {
    throw new Error('App globals not initialized.');
  }
  return globalProps;
}